// @flow

import React, {useState} from "react";
import {Form, InputNumber, Popover, Button, message} from "antd";
import {useTranslation} from "react-i18next";
import {useStore} from "../../../../hooks/useStore";

export const SlotCreatePopConfirm = ({
    poolId,
    forecastDate,
    slotDate,
    hourId,
    minLimit = 1,
    recall = () => {},
    disabled = false,
    children
}) => {
    const stores = useStore();
    const [slotLimit, setSlotLimit] = useState(1);
    const {t} = useTranslation();
    const submitForm = async () => {
        try {
            if (!poolId) {
                message.error("Havuz seçiniz");
                return;
            }

            if (!slotDate || !forecastDate) {
                message.error("Tarih seçiniz");
                return;
            }

            if (!hourId) {
                message.error("Saat seçiniz");
                return;
            }

            if (!slotLimit || slotLimit < 0) {
                message.error("Limit 0'dan büyük olmalıdır");
                return;
            }

            const createSlotResult = await stores.poolShiftStore.createPoolShiftDailySlot({
                poolId,
                shiftHourId: hourId,
                forecastDate,
                slotDate,
                limit: slotLimit
            });

            if (!createSlotResult) {
                return;
            }
            message.success("Slot oluşturuldu");
            recall();
        } catch (error) {
            let errorMessage =
                error?.message ||
                t("errorMessages.AnUnknownErrorWasOccurred", {
                    ns: "common"
                });
            if (error?.errors?.length > 0) {
                errorMessage = error.errors.join("\n");
            }
            stores.appStore.openErrorModal({content: errorMessage});
        }
    };

    const renderForm = () => {
        return (
            <Form autoComplete="off" layout="inline" labelCol={{span: 24}} wrapperCol={{span: 24}}>
                <Form.Item>
                    <InputNumber
                        name="slotLimit"
                        value={slotLimit}
                        min={minLimit}
                        onChange={e => setSlotLimit(e)}
                        data-testid="slotLimitInput"
                    />
                </Form.Item>
                <Button onClick={submitForm}>Oluştur</Button>
            </Form>
        );
    };

    return disabled ? (
        <>{children}</>
    ) : (
        <Popover
            trigger={"click"}
            title={"Slot Oluştur"}
            content={renderForm}
            overlayStyle={{
                width: "300px"
            }}
            onConfirm={submitForm}
            okText={t("modal.sendButton", {ns: "common"})}
            cancelText={t("modal.cancelButton2", {
                ns: "common"
            })}
        >
            {children}
        </Popover>
    );
};
